var Model = require('../Model');

var hasEquipment = Object.create(Model);

hasEquipment.name = 'hasEquipment';
hasEquipment['@class'] = 'hasEquipment';
hasEquipment.url = 'hasEquipment';
hasEquipment.isEdge = true;
hasEquipment.fields = {
  parentSystem:{
    default: null,
    hidden: true
  },
	childEquipment: {
    default: null,
    hidden: true
	},
};

module.exports = hasEquipment;